<template>
  <v-select 
    :clearable="true" 
    :options="filter.options" 
    :multiple="false" 
    :placeholder="filter.label" 
    :label="labelKey"
    :value="value"
    class="vf-select"
    @input="$emit('set-filter', $event)"
    style="margin:0 0 1rem 0">
  </v-select>
</template>

<script>
import Deselect from '@/Deselect'
import OpenIndicator from '@/OpenIndicator'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
vSelect.props.components.default = () => ({ OpenIndicator, Deselect })

export default {
  name: 'DropdownFilter',
  components: {
    vSelect
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  data () {
    return {
      labelKey: 'title',
      attributes: {
        ref: 'openIndicator',
        role: 'presentation',
        class: 'vs__open-indicator',
      }
    }
  }
}
</script>
